import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Observable } from 'rxjs';
import { UserService } from '../services/user.service';

@Injectable({ providedIn: 'root' })
export class InitialFetchGuard implements CanActivate {
  constructor(private readonly _userService: UserService) {}

  public canActivate(): Observable<boolean> {
    return this._userService.initialFetch$;
  }
}
